<template>
  <div class="page-bg">
    <!-- Header -->
    <Header :headerTitle="$t('m.userCenter.title')" :hasBackBtn="true"></Header>
    <div>
      <van-cell-group inset  style="margin-top:10px">
        <van-cell class="u-cell-row u-icon" @click="personalDate" is-link>
          <template #title>
            <van-row>
              <van-col :span="6">
                <b-img v-if="resultList.gender==2 || resultList.gender==null || resultList.gender==''"
                  left
                  class="avatar"
                  rounded="circle"
                  :src="require('../../assets/img/touxiangwoman.png')"
                  width="60px"
                />
                  <b-img v-if="resultList.gender==1"
                  left
                  class="avatar"
                  rounded="circle"
                  :src="require('../../assets/img/touxiangman.png')"
                  width="60px"
                />
              </van-col>
              <van-col :span="12" style="padding-top: 2%;">
                <b-row>
                  <b-col>
                    <span right class="u-phone">{{resultList.phone}}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="license-col">
                    <span right class="car-num-bg" v-if="resultList.licenseplate">{{resultList.licenseplate}}</span>
                    <span right class="car-num-bg" v-if="!resultList.licenseplate">{{$t('m.userCenter.provinceName')}}</span>
                  </b-col>
                </b-row>
              </van-col>
            </van-row>
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group inset style="margin-top:10px">
        <van-cell class="u-cell-row" @click="showModal" is-link size="large">
          <template #title>
            <b-img left rounded="circle" :src="require('../../assets/img/vip.png')" width="20"/>
            <span class="title">{{$t('m.userCenter.vipTitle')}}</span>
          </template>
        </van-cell>
        <van-cell class="u-cell-row" @click="onOrderList" is-link size="large">
          <template #title>
            <b-img left rounded="circle" :src="require('../../assets/img/order.png')" width="20"/>
            <span class="title">{{$t('m.userCenter.orderTitle')}}</span>
          </template>
        </van-cell>
        <van-cell class="u-cell-row" @click="invoicing" is-link size="large">
          <template #title>
            <b-img left rounded="circle" :src="require('../../assets/img/fapiao.png')" width="20"/>
          <span class="title">{{$t('m.userCenter.invoicesTitle')}}</span>
          </template>
        </van-cell>
        <van-cell class="u-cell-row" @click="$router.push('/userHelp')" is-link size="large">
          <template #title>
            <b-img left rounded="circle" :src="require('../../assets/img/bangzhu.png')" width="20"/>
            <span class="title">{{$t('m.userCenter.helpTitle')}}</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
       <b-modal
          ref="introduction"
          class="introduce"
          ok-only
          :ok-title="$t('m.home.ok')"
          @ok="confirm()"

      >
      <h5 style="font-weight:bold">
         {{$t('m.home.introduceTitle')}}
      </h5>
        <p
            class="my-3"
            style="text-align:left;margin-bottom:5px !important;padding:0 25px;font-size:15px;white-space:pre-line"
        >{{$t('m.home.introduction')}}</p>
      <p style="font-size:0.9rem;font-weight:bold;margin-top:1rem" >
         {{$t('m.home.introduceFooter')}}    <a style="color:#0066B1;font-size:0.9rem;margin-top:1rem;font-weight:light"  href="tel:400-115-0606">400-115-0606</a>
      </p>
      </b-modal>
    <footer>
      <span v-b-modal.modal-center>{{$t('m.userCenter.logOut')}}</span>
      <!-- modal -->
      <b-modal
        id="modal-center"
        centered
        :title="$t('m.userCenter.logOutTitle')"
        body-class="loginout-body"
        ok-variant
        :ok-title="$t('m.userCenter.ok')"
        :cancel-title="$t('m.userCenter.cancel')"
        @ok="onLogin()"
      ></b-modal>
    </footer>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>

<script>
import { userInfo } from "../../api/user.js";
import { logout } from "../../api/login.js";
export default {
  name: "userCenter",
  data() {
    return {
      resultList: {}, //数据
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //开具发票
    invoicing: function() {
      this.$router.push("/invoicing");
    },
    //查看个人信息
    personalDate: function() {
      this.$router.push("/personalData");
    },
    //订单列表
    onOrderList: function() {
      this.$router.push("/OrderList/0");
    },
    //退出登录
    onLogin: function() {
      logout().then(response => {
        if (response.data.status === 200){
          localStorage.removeItem("token");
          this.$router.push("/Login");
        } else{
          this.tipShow = "1" + Math.random() * 1000;
          this.message = '退出失败 , 请重试';
          this.tipType = "warning";
        }
      })

    },
    confirm(){
      this.$router.push("/bindingVip");
    },
    showModal() {
      if( this.resultList.vipCards.length <= 0 || !this.resultList.vipCards.find(e=>e.serviceType != 3)){
         this.$refs['introduction'].show();
      }else{
         this.$router.push("/vipInfo");
      }
    },
    //获取数据
    loadUserInfo: function() {
      userInfo().then(
        response => {
          if (response.data.status == 200) {
            this.resultList = response.data.result;
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }
  },
  created() {
    this.loadUserInfo();
  }
};
</script>

<style scoped>

a {
  color: #2c3e50;
}

a:link {
  text-decoration: none;
  color: #2c3e50;
}

a:visited {
  text-decoration: none;
  color: #2c3e50;
}

span {
  text-align: right;
  font-family: HiraginoSansGB-W6;
}

.container {
  padding-top: 10px;
}

.avatar {
  position: relative;
  top: 3px;
}

.phone {
  text-align: right;
  padding-right: 0px;
}

.phone .col {
  padding-right: 10px;
}

.phone span.number {
  font-size: 25px !important;
}

.phone span.license {
  width: 40%;
  display: inline-block;
  text-align: center;
  background-color: #ccc;
  line-height: 30px;
}

.bind-vip {
  height: 63px;
  line-height: 63px;
  border: 1px solid #e6e6e6;
  text-align: left;
  margin: 20px 0px;
  margin-top: 30px;
  margin-bottom: 5px;
  border-radius: 5px;
  font-size: 13px;
}

.list-group .item {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: left;
}

.list-group .item span {
  margin-left: 10px;
  font-size: 15px;
}
.list-group .item img {
  margin-top: 3px;
}
.triangle_border_right {
  width: 0;
  height: 0;
  border-width: 6px 0 6px 6px;
  border-style: solid;
  border-color: transparent transparent transparent #d1d1d1;
  /*透明 透明 透明 灰*/
  position: relative;
  float: right;
  top: 6px;
}

.info-triangle-btn {
  margin: 0px;
  padding: 0px;

}

.info-triangle-btn img{
  height:25px;
  margin-top:17px
}

.info-triangle-btn .triangle_border_right {
  top: 24px;
  float: left;
  margin-left: 18px;
}

.bind-vip .triangle_border_right {
  top: 24px;
}
footer {
  margin-top: 100px;
  color: #0066B1;
  /* height: 90px; */
  margin: 0 10px;
  position: fixed;
  bottom: 30px;
  left: 0;
  width: 93%;
}

</style>
<style>
.introduce .modal-content {
    margin: 0 auto;
    margin-top:100px;
    width:95%;
}
.introduce .modal-header{

    padding: 0rem;

}
footer .loginout-body {
  display: none !important;
  margin: 0px;
}
footer .modal-content .modal-footer .btn-secondary:last-child{
  margin-right:0px;
  color: #fff;
  background-color: #0066B1;
}
footer .modal-content{
  width: 80%;
  margin-left: 10%;
}
.u-cell-row{
  text-align: left;
  font-size: 16px;
  color: #2c3e50;
}
.u-cell-row .van-cell__value{
  text-align: left;
}
.u-cell-row .van-cell__value .title{
  margin-left: 10px;
  color: #2c3e50;
}
.u-phone{
  color:#000000 ;
}
.car-num-bg{
  color: rgba(0, 97, 177, 1);
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  border: 1px solid rgba(0, 97, 177, 1);
  border-radius: 6px;
  width: 75px;
  background: #EAF5FD;
  padding: 6px;
  display: inline;
  top: 2%;
  margin-top: 13px;
}
.u-icon .van-icon{
  margin-top: 5%;
}
</style>
